import { useAppDispatch, useAppSelector } from '../../../../../shared/libs/redux';
import { privateTemplateModuleTagGroupAPI } from '../../../../../entities/template/private-template-tag-group/template-tag-group/api/privateTemplateModuleTagGroupAPI';
import { privateTemplateModuleTagActions } from '../../../../../entities/module/private-template-module-tag/model/template-module-tag';
import { TagGroupType } from '../../../../../entities/template/private-template-tag-group/model/types';

export const useSelectedPrivateModuleGroupTags = () => {
	const dispatch = useAppDispatch();

	const selectedTags = useAppSelector(state => state.templateModuleTag.currentTagsIds);

	const { data: tagsData } = privateTemplateModuleTagGroupAPI.useGetAllQuery({
		page: 1,
		limit: 127,
		search: '',
	});

	const onSetCurrentIds = (preparedIds: number[]) => {
		dispatch(privateTemplateModuleTagActions.setCurrentTagsIds(preparedIds));
	};

	const onSelectTag = (id: number) => {
		if (selectedTags.includes(id)) {
			const preparedIds = selectedTags.filter(tag => tag !== id);

			onSetCurrentIds(preparedIds);
		} else {
			const preparedIds = [...selectedTags, id];

			onSetCurrentIds(preparedIds);
		}
	};

	const onRemoveTag = (tagId: number) => {
		const preparedIds = selectedTags.filter(id => id !== tagId);
		onSetCurrentIds(preparedIds);
	};

	const onCleanSelectedTagList = () => onSetCurrentIds([]);

	const onCleanSelectedGroupTags = (groupId: string | undefined) => {
		if (!groupId || !tagsData?.tagGroups) return;

		if (groupId === TagGroupType.tagsWithoutGroup) {
			onSetCurrentIds([]);
			return;
		}

		const group = tagsData.tagGroups.find(g => g.id === groupId);
		if (group) {
			const preparedIds = selectedTags.filter(tagId => !group.tags.some(tag => tag.id === tagId));
			onSetCurrentIds(preparedIds);
		}
	};

	return {
		selectedTags,
		onSelectTag,
		onRemoveTag,
		onCleanSelectedTagList,
		onCleanSelectedGroupTags,
	};
};
